import { ISmplPose } from '@seddi/avatar';
import { Avatar } from '../../avatars';
import { Garment, Style } from '../../garments';

export type HomeStateExt = {
  avatar: Avatar | null;
  garment: Garment | null;
  pose: ISmplPose | null;
  style: Style | null;
  stylePoses: ISmplPose[] | null;
};

export const homeStateExt: HomeStateExt = {
  avatar: null,
  garment: null,
  pose: null,
  style: null,
  stylePoses: null,
};

export const initHomeStateExt = () => {
  homeStateExt.avatar = null;
  homeStateExt.garment = null;
  homeStateExt.pose = null;
  homeStateExt.style = null;
  homeStateExt.stylePoses = null;
};
